var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lg:col-span-1"},[_c('div',{staticClass:"text-xs font-semibold lg:text-sm"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"text-xs lg:text-sm"},[_vm._v(" "+_vm._s(_vm.value)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }